export class BrandingConfigurationResultDto {
  managementCompany: string;
  taglineText: string;
  website: string;
  phone: string;
  fax: string;
  tollFreePhone: string;
  boardSurveySite: string;
  managementReportSurveySite: string;
  financialReportSurveySite: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  brandingImageUrl: string;
  brandingHiresImageUrl: string;
  taglineImageUrl: string;
}
